import { render } from "./DashboardDrawer.vue?vue&type=template&id=4d73dc21&ts=true"
import script from "./DashboardDrawer.vue?vue&type=script&lang=ts"
export * from "./DashboardDrawer.vue?vue&type=script&lang=ts"

import "./DashboardDrawer.vue?vue&type=style&index=0&id=4d73dc21&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__